import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const StepLabel: FC<Props> = ({ children }) => {
  return (
    <Flex bottom={-3} justify="center" left={0} position="absolute" w="full">
      <Text
        bg="th.cream1"
        border="1px solid"
        borderColor="th.blueGreen2"
        borderRadius="full"
        color="th.blueGreen2"
        px={2}
        py={1}
        textTransform="uppercase"
        variant="th-t3"
      >
        {children}
      </Text>
    </Flex>
  );
};
